import { HeatData } from "@/pages/heat-report/models/HeatReportModels";
import { CatalogGradeMechanicalLimit } from "@/pages/laboratory/models/CatalogGradeMechanicalLimit";
import { CatalogMechanicalTest } from "@/pages/laboratory/models/CatalogMechanicalTest";
import { CatalogResultSource } from "@/pages/laboratory/models/CatalogResultSource";
import { DynamicMechanicalSample } from "@/pages/laboratory/models/DynamycMechanicalSample";
import { MechanicalSample } from "@/pages/laboratory/models/MechanicalSample";
import { useTablesStyles } from "@/pages/shift-report/styles/useTablesStyles";
import { Grid2 as Grid, Paper, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useMemo, useRef } from "react";
import { useMechanicalTestTableData } from "./hooks/useMechanicalTestTableData";

interface MechanicalTestTableProps {
	loadingGrid: boolean;
	heat: HeatData | null;
	mechanicalSamples: MechanicalSample[] | null;
	mechanicalTests: CatalogMechanicalTest[] | null;
	mechanicalGradeLimits: CatalogGradeMechanicalLimit[] | null;
	mechanicalResultSources: CatalogResultSource[] | null;
}

export const MechanicalTestTable = ({
	loadingGrid,
	heat,
	mechanicalSamples,
	mechanicalTests,
	mechanicalGradeLimits,
	mechanicalResultSources,
}: MechanicalTestTableProps) => {
	const classes = useTablesStyles();
	const gridRef = useRef<AgGridReact<DynamicMechanicalSample>>(null);

	// Transform data using the hook
	const { columns, rows, defaultColDef } = useMechanicalTestTableData({
		mechanicalSamples: mechanicalSamples || [],
		mechanicalTests: mechanicalTests || [],
		mechanicalGradeLimits: mechanicalGradeLimits || [],
		mechanicalResultSources: mechanicalResultSources || [],
	});

	// Grid style
	const gridStyle = useMemo(
		() => ({
			height: "auto",
		}),
		[],
	);

	// Handle loading overlay
	useMemo(() => {
		if (loadingGrid && gridRef.current?.api) {
			gridRef.current.api.showLoadingOverlay();
		} else if (gridRef.current?.api) {
			gridRef.current.api.hideOverlay();
		}
	}, [loadingGrid]);

	return (
		<Grid
			size={{ xs: 12 }}
			container
			className={classes.root}
			style={{ ...gridStyle }}
		>
			<Grid size={{ xs: 12 }}>
				<Paper elevation={1}>
					<AgGridReact<DynamicMechanicalSample>
						ref={gridRef}
						rowSelection="single"
						pagination={false}
						animateRows={true}
						domLayout="autoHeight"
						tooltipShowDelay={0}
						tooltipHideDelay={2000}
						rowData={rows}
						columnDefs={columns}
						suppressContextMenu={true}
						// Enable Excel export
						enableRangeSelection={true}
						enableCharts={false}
					/>
				</Paper>
			</Grid>
		</Grid>
	);
};
